// lib
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import moment from "moment";
// src
import enTranslation from "./locales/en.json";
import frTranslation from "./locales/fr.json";

const resources = {
  en: { translation: enTranslation },
  fr: { translation: frTranslation },
};

const detection = {
  order: ["navigator"],
  checkWhitelist: false,
  checkForSimilarInWhitelist: true,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    load: "all",
    whitelist: ["en", "fr"],
    detection,
    resources,
  });

export const languages = ["en", "fr"];

export const changeLanguage = (l) => {
  moment.locale(l);
  return i18n.changeLanguage(l);
};

export const selfTranslate = (name, locale) => {
  if (!name) return "";
  const l = locale || i18n.language;
  return !l || !name[l] ? name : name[l];
};

export default i18n;
